import React, { useState } from 'react'
import './contactUsForm.css';
import CenterStage from '../../Components/CenterStage/CenterStage';
import TwoColumnPoints from '../../Components/TwoColumnPoints/TwoColumnPoints';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import HFTab from '../../Components/HfTabs/HfTabs';
import TextCaption from '../../Components/TextCaption/TextCaption';
import imgMHSBrazil from '../../assets/BrazilServicos/MHSBrazil.jpeg';
import imgMHS1 from '../../assets/BrazilServicos/MHS1.jpg';
import imgMHS2 from '../../assets/BrazilServicos/MHS2.jpg';
import imgMHS3 from '../../assets/BrazilServicos/MHS3.jpg';
import imgMHS4 from '../../assets/BrazilServicos/MHS4.jpg';
import { FaEnvelope, FaExclamationCircle, FaPhone, FaUser } from 'react-icons/fa'
import { useTranslation } from 'react-i18next';
import WhatsAppChat from '../../Components/WhatsAppChat/WhatsAppChat';

const MhsCampaignMS = () => {
    const SOURCE = 'mhs-campaign-ms'
    const MAX_MESSAGE_LENGTH = 1000
    const { t } = useTranslation();

    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        telephone: '',
        cpfCnpj: '',
        message: ''
    })
    const [errors, setErrors] = useState({})
    const [touched, setTouched] = useState({})
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [submitSuccess, setSubmitSuccess] = useState(false)

    const formatTelephone = (value) => {
        const numbers = value.replace(/\D/g, '')
        if (numbers.length <= 10) return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
        return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    }

    const formatCpfCnpj = (value) => {
        const numbers = value.replace(/\D/g, '')
        if (numbers.length <= 11) return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    }

    const validateField = (name, value) => {
        const v = (value ?? '').toString()
        let error = ''

        switch (name) {
            case 'fullName':
                if (!v.trim()) error = 'Full name is required'
                else if (v.trim().length < 2) error = 'Full name must be at least 2 characters'
                break
            case 'email':
                if (!v.trim()) error = 'Email is required'
                else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) error = 'Please enter a valid email address'
                break
            case 'telephone':
                if (!v.trim()) error = 'Telephone is required'
                else if (v.replace(/\D/g, '').length < 10) error = 'Please enter a valid telephone number'
                break
            case 'cpfCnpj':
                if (!v.trim()) error = 'CPF/CNPJ is required'
                else {
                    const numbers = v.replace(/\D/g, '')
                    if (numbers.length !== 11 && numbers.length !== 14) error = 'CPF must have 11 digits or CNPJ must have 14 digits'
                }
                break
            case 'message':
                if (!v.trim()) error = 'Message is required'
                else if (v.trim().length < 10) error = 'Message must be at least 10 characters'
                else if (v.length > MAX_MESSAGE_LENGTH) error = `Message must not exceed ${MAX_MESSAGE_LENGTH} characters`
                break
            default:
                break
        }

        return error
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        let processedValue = value
        if (name === 'telephone') processedValue = formatTelephone(value)
        if (name === 'cpfCnpj') processedValue = formatCpfCnpj(value)

        setFormData(prev => ({ ...prev, [name]: processedValue }))

        if (touched[name]) {
            const error = validateField(name, processedValue)
            setErrors(prev => ({ ...prev, [name]: error }))
        }
    }

    const handleBlur = (e) => {
        const { name, value } = e.target
        setTouched(prev => ({ ...prev, [name]: true }))
        const error = validateField(name, value)
        setErrors(prev => ({ ...prev, [name]: error }))
    }

    const validateForm = () => {
        const requiredFields = ['fullName', 'email', 'telephone', 'cpfCnpj', 'message']
        const newErrors = {}
        const newTouched = {}

        requiredFields.forEach((key) => {
            newTouched[key] = true
            const err = validateField(key, formData[key])
            if (err) newErrors[key] = err
        })

        setTouched(prev => ({ ...prev, ...newTouched }))
        setErrors(prev => ({ ...prev, ...newErrors }))
        return Object.keys(newErrors).length === 0
    }

    const resetForm = () => {
        setFormData({
            fullName: '',
            email: '',
            telephone: '',
            cpfCnpj: '',
            message: ''
        })
        setTouched({})
        setErrors({})
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validateForm()) return

        setIsSubmitting(true)
        setSubmitSuccess(false)
        setErrors(prev => ({ ...prev, submit: '' }))

        try {
            const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.hansa-flex.co.in'
            const API_URL = `${API_BASE}/api/hf-brazil/contact/${SOURCE}`

            const composedMessage = `Campaign: MHS (MS)\n\n${formData.message}`

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    source: SOURCE,
                    fullName: formData.fullName,
                    email: formData.email,
                    telephone: formData.telephone,
                    cpfCnpj: formData.cpfCnpj,
                    message: composedMessage
                })
            })

            const data = await response.json().catch(() => ({}))
            if (!response.ok) throw new Error(data.error || 'Failed to send')

            setSubmitSuccess(true)
            setTimeout(() => {
                resetForm()
                setSubmitSuccess(false)
                setIsSubmitting(false)
            }, 5000)
        } catch (error) {
            setErrors(prev => ({ ...prev, submit: error.message || 'Failed to send. Please try again later.' }))
            setIsSubmitting(false)
        }
    }
    const listItems = [
        "Technical expertise and customization capabilities;",
        "Certified equipment and components;",
        "Responsive service, including mobile workshops;",
        "Integrated solutions for industrial, logistics, and operational applications;",
    ];

    const imageTextData = [
        {
            title: "Always close to you",
            description: "At HANSA-FLEX, MHS never stops. Our mobile units are distributed throughout Brazil, ready to reach you whenever you need them. Just give us a call and one of our technicians will be on their way, bringing fast and reliable solutions wherever your operation is located.",
            listItems: "",
            buttonName: "LEARN MORE",
            buttonLink: "/MHS",
            image: imgMHS1
        },
        {
            title: "Fewer stops, more productivity",
            description: "When we talk about MHS, we talk about true agility.We plan each service call efficiently, use digital tools, and maintain real-time communication between the branch and field technicians.This way, we ensure that your equipment is back up and running with minimal downtime and maximum performance.",
            listItems: "",
            buttonName: "LEARN MORE",
            buttonLink: "/MHS",
            image: imgMHS2
        },
        {
            title: "Qualified professionals",
            description: "Behind every HANSA-FLEX MHS is an experienced professional committed to delivering speed and quality in every service call.Our technicians have specialized training and use their technical and practical knowledge to solve any hydraulic challenge on site.",
            listItems: "",
            buttonName: "LEARN MORE",
            buttonLink: "/career",
            image: imgMHS3
        },
        {
            title: "Certified quality",
            description: "At HANSA-FLEX, quality and safety go hand in hand.We comply with ISO 9001 standards and occupational safety regulations, ensuring reliable processes and results.All components used are tested and approved according to the same criteria of excellence applied to our hoses, fittings, and hydraulic systems.",
            listItems: "",
            buttonName: "LEARN MORE",
            buttonLink: "/certification",
            image: imgMHS4
        },
    ];

    const tabTitles = [
        { title: "Always close to you", eventKey: "Fittings" },
        { title: "Fewer stops, more productivity", eventKey: "Couplings" },
        { title: "Qualified professionals", eventKey: "Adapters1" },
        { title: "Certified quality", eventKey: "Adapters2" },
    ];
    return (
        <div>            <CenterStage imageSrc={imgMHSBrazil} title={"READY TO ACT AT ANY TIME: MHS (MOBILE HYDRAULIC SERVICE)"} paragraph={"Our Mobile Hydraulic Service (MHS) is always available to you, to minimise your downtime."} />

            <div>
                <TwoColumnPoints points={listItems} title={"Technical Expertise & Integrated Solutions"} />
            </div><br /><br />
            <br /><br />
            <div className="contact-caption ">
                <TextCaption
                    paragraph="MHS – HANSA-FLEX Mobile Hydraulic Service is a technical support solution in the field for emergency repairs and maintenance on hydraulic systems."
                />
            </div>

            <div className="contact-caption">
                <TextCaption
                    paragraph="With fully equipped mobile workshops and specialized technicians, MHS guarantees a quick response, reduced downtime, and the same quality of service provided at HANSA-FLEX units, directly at the site of operation."
                />
            </div>

            <div className="contact-caption">
                <TextCaption
                    paragraph="Fill out the form or click on the WhatsApp button to get in touch."
                />
            </div>
            <div className='contact-form-container'>
                <h1 className="contact-form-title">{t('MHS Contact Form (MS)')}</h1>
                <p className="contact-form-instruction">{t('Please fill out the form below')}</p>

                <form className="contact-form" onSubmit={handleSubmit} style={{ pointerEvents: isSubmitting ? 'none' : 'auto', opacity: isSubmitting ? 0.7 : 1 }}>
                    <div className="form-group">
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="fullName"
                                placeholder={t('Full Name*')}
                                value={formData.fullName}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                                className={`form-input ${errors.fullName ? 'input-error' : ''} ${touched.fullName && !errors.fullName && formData.fullName ? 'input-valid' : ''}`}
                                aria-label="Name"
                                aria-required="true"
                                aria-invalid={!!errors.fullName}
                                disabled={isSubmitting}
                                autoFocus
                            />
                            <FaUser className="input-icon" />
                        </div>
                        {errors.fullName && (
                            <span className="error-message" role="alert">
                                <FaExclamationCircle className="error-icon" />
                                {t(errors.fullName)}
                            </span>
                        )}
                    </div>

                    <div className="form-group">
                        <div className="input-wrapper">
                            <input
                                type="email"
                                name="email"
                                placeholder={t('Email*')}
                                value={formData.email}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                                className={`form-input ${errors.email ? 'input-error' : ''} ${touched.email && !errors.email && formData.email ? 'input-valid' : ''}`}
                                aria-label="E-mail"
                                aria-required="true"
                                aria-invalid={!!errors.email}
                                disabled={isSubmitting}
                            />
                            <FaEnvelope className="input-icon" />
                        </div>
                        {errors.email && (
                            <span className="error-message" role="alert">
                                <FaExclamationCircle className="error-icon" />
                                {t(errors.email)}
                            </span>
                        )}
                    </div>

                    <div className="form-group">
                        <div className="input-wrapper">
                            <input
                                type="tel"
                                name="telephone"
                                placeholder={t('Telephone*')}
                                value={formData.telephone}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                                className={`form-input ${errors.telephone ? 'input-error' : ''} ${touched.telephone && !errors.telephone && formData.telephone ? 'input-valid' : ''}`}
                                aria-label="Telephone"
                                aria-required="true"
                                aria-invalid={!!errors.telephone}
                                disabled={isSubmitting}
                            />
                            <FaPhone className="input-icon" />
                        </div>
                        {errors.telephone && (
                            <span className="error-message" role="alert">
                                <FaExclamationCircle className="error-icon" />
                                {t(errors.telephone)}
                            </span>
                        )}
                    </div>

                    <div className="form-group">
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="cpfCnpj"
                                placeholder={t('CPF/CNPJ*')}
                                value={formData.cpfCnpj}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                                className={`form-input ${errors.cpfCnpj ? 'input-error' : ''} ${touched.cpfCnpj && !errors.cpfCnpj && formData.cpfCnpj ? 'input-valid' : ''}`}
                                aria-label="CPF or CNPJ"
                                aria-required="true"
                                aria-invalid={!!errors.cpfCnpj}
                                disabled={isSubmitting}
                            />
                        </div>
                        {errors.cpfCnpj && (
                            <span className="error-message" role="alert">
                                <FaExclamationCircle className="error-icon" />
                                {t(errors.cpfCnpj)}
                            </span>
                        )}
                    </div>

                    <div className="form-group message-group">
                        <textarea
                            name="message"
                            placeholder={t('Message*')}
                            value={formData.message}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            maxLength={MAX_MESSAGE_LENGTH}
                            className={`form-textarea ${errors.message ? 'input-error' : ''} ${touched.message && !errors.message && formData.message ? 'input-valid' : ''} ${formData.message.length >= MAX_MESSAGE_LENGTH ? 'char-limit-reached' : ''}`}
                            rows="6"
                            aria-label="Message"
                            aria-required="true"
                            aria-invalid={!!errors.message}
                            disabled={isSubmitting}
                        />
                        <div className="textarea-footer">
                            {errors.message && (
                                <span className="error-message" role="alert">
                                    <FaExclamationCircle className="error-icon" />
                                    {t(errors.message)}
                                </span>
                            )}
                        </div>
                    </div>

                    {errors.submit && (
                        <div className="error-message" style={{ marginTop: '10px', marginBottom: '10px' }} role="alert">
                            <FaExclamationCircle className="error-icon" />
                            {t(errors.submit)}
                        </div>
                    )}

                    {submitSuccess && (
                        <div style={{ marginTop: '10px', marginBottom: '10px', color: 'green' }}>
                            {t('Submitted successfully. Please check your email.')}
                        </div>
                    )}

                    <button
                        type="submit"
                        className={`submit-button ${isSubmitting ? 'submitting' : ''}`}
                        disabled={isSubmitting}
                        aria-label="Submit MHS MS form"
                    >
                        {isSubmitting ? t('Sending...') : t('Send')}
                    </button>
                </form>
            </div>
            <div>
                <SectionHeader
                    title={"HANSA-FLEX'S MHS (MOBILE HYDRAULIC SERVICE) OFFERS MANY ADVANTAGES"}
                    subtitle={"With fully equipped mobile workshops and specialized technicians, MHS guarantees a quick response, reduced downtime, and the same quality of service provided at HANSA-FLEX units, directly at the site of operation."}
                />
                <HFTab imageTextData={imageTextData} tabTitles={tabTitles} />
            </div>
            <br /><br />
            <WhatsAppChat phoneNumber="+55 (47) 98805-1323" />
        </div>
    );
};

export default MhsCampaignMS